(() => {
	angular.module('main').directive('maxAmountValidator', maxAmountValidator);

	maxAmountValidator.$inject = [];

	function maxAmountValidator() {
		return {
			restrict: 'A',
			scope: {},
			replace: true,
			transclude: true,
			link(scope, element, attrs) {
				$(element).bind('change', function() {
					const validity = element.prop('validity');
					if (validity.rangeOverflow) {
						const max = attrs.max;
						const amountOverflowError = `
                            You must record an amount that is equal to or less than ${max}. 
                            If you have received a larger amount, record this payment and then 
                            add the remaining amount to the next payment.
                        `;
						$(this).setCustomValidity(amountOverflowError);
					} else {
						$(this).setCustomValidity('');
					}
				});
			}
		};
	}
})();



// WEBPACK FOOTER //
// ./web/js/components/Elements/maxAmountValidator.js